// extracted by mini-css-extract-plugin
export default {"card":"Notification_card__sZ0l+","head":"Notification_head__ZhfkI","date":"Notification_date__EAvKm"};